import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useCallback } from 'react';
import classnames from 'classnames/bind';
import { Message } from 'semantic-ui-react';
import { ColorNames } from '../../../constants/colorVars';
import Button from '../button';
import Icon from '../icon';
import Text from '../text';
import cls from './styles.scss';
import moment from 'moment';
const cx = classnames.bind(cls);
const defaultIconName = {
    info: 'info-circle',
    caution: 'exclamation-triangle',
    error: 'exclamation-circle',
    success: 'check-circle',
    '': '',
};
const Alert = ({ role, type = 'inline', header, content, slots, onDismiss, className, showIcon, icon, iconName, elmId = 'alert_message', contentOnTop = false, timestamp, timestampPrefix, timestampRefreshInMS = 60000, ...restProps }) => {
    const defaultIcon = (role || iconName) && (_jsx("div", { className: cx('icon-container', { 'with-timestamp': !!timestamp }), children: _jsx(Icon, { style: role === 'caution' ? { transform: 'translateY(-2px)' } : {}, name: iconName || defaultIconName[role ?? ''], color: 'unspecified', iconStyle: 'solid', size: 'big', fitted: true }) }));
    const iconElement = showIcon && (icon || defaultIcon);
    const wrappedContent = typeof content === 'string' ? (_jsx(Text, { "data-elm-id": 'content', color: '', size: 'unset', children: content })) : (content);
    const actionSlot = slots?.action?.();
    const augmentedActionSlot = React.isValidElement(actionSlot) && actionSlot.type === Button
        ?
            React.cloneElement(actionSlot, {
                ...actionSlot.props,
                role: 'auxiliary',
                color: role || ColorNames.Gray,
            })
        : actionSlot;
    const secondaryActionSlot = slots?.secondaryAction?.();
    const augmentedSecondaryActionSlot = React.isValidElement(secondaryActionSlot) &&
        secondaryActionSlot.type === Button
        ?
            React.cloneElement(secondaryActionSlot, {
                ...secondaryActionSlot.props,
                role: 'auxiliary',
                color: ColorNames.Gray,
            })
        : secondaryActionSlot;
    const getElapsedTime = useCallback(() => {
        if (timestamp) {
            const elapsed = moment(timestamp).fromNow();
            const capitalizedElapsed = elapsed.charAt(0).toUpperCase() + elapsed.slice(1);
            return timestampPrefix ? elapsed : capitalizedElapsed;
        }
        return '';
    }, [timestamp, timestampPrefix]);
    const initTimestamp = timestamp ? getElapsedTime() : '';
    const [elapsedTime, setElapsedTime] = useState(initTimestamp);
    useEffect(() => {
        let timeoutId;
        function updateElapsedTime() {
            clearTimeout(timeoutId);
            const elapsed = getElapsedTime();
            setElapsedTime(elapsed);
            timeoutId = setTimeout(updateElapsedTime, timestampRefreshInMS);
        }
        if (timestamp) {
            timeoutId = setTimeout(updateElapsedTime, timestampRefreshInMS);
        }
        return () => {
            clearTimeout(timeoutId);
        };
    }, [getElapsedTime, timestamp, timestampPrefix, timestampRefreshInMS]);
    return (_jsxs(Message, { className: cx('alert', role ? `alert-${role}` : 'alert-none', {
            'inline-alert': type === 'inline',
            'page-banner': type === 'pageBanner',
            'overlay-banner': type === 'overlayBanner',
        }, className), icon: !!iconElement, "data-elm-id": elmId, onDismiss: onDismiss, ...restProps, children: [iconElement, _jsxs(Message.Content, { children: [timestamp && (_jsxs(Text, { size: 'tiny', color: '', className: cx('timestamp'), children: [timestampPrefix, elapsedTime] })), _jsxs("div", { className: cx('header-and-content', {
                            'content-on-top': contentOnTop,
                        }), children: [header && _jsx(Header, { role: role, children: header }), wrappedContent] })] }), (slots?.action || slots?.secondaryAction) && (_jsxs("div", { className: cx('action-content', {
                    dismissible: !!onDismiss,
                    'with-timestamp': !!timestamp,
                }), children: [augmentedSecondaryActionSlot, augmentedActionSlot] }))] }));
};
const Header = ({ className, children, }) => {
    return (_jsx(Message.Header, { className: cx('alert-header', className), "data-elm-id": 'header', children: children }));
};
const AlertWithStatics = Alert;
AlertWithStatics.Header = Header;
export default AlertWithStatics;
//# sourceMappingURL=index.js.map